module.exports = __webpack_public_path__ + "img/neutral_face.cac3d178.png";